import { Typography } from "@mui/material";
import {
  NoteWrapper,
  RiskItem,
  RiskLabel,
  SuccessPlanCard,
  useSpContext,
} from "components/summary/success-plan";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import styles from "../SuccessPlan.module.scss";
import moment from "moment-timezone";

type CustomerHealthSectionProps = {
  spState: SuccessPlanState;
};

const CustomerHealthSection = ({ spState }: CustomerHealthSectionProps) => {
  const { riskItems } = useSpContext();
  const { spData } = spState;
  const {
    customerRisk,
    customerRiskNote,
    significantDoing,
    escalationFlag,
    escalationNote,
    deRiskStrategies,
  } = spData;
  const histories = spData.histories || [];

  const riskItem: RiskItem | undefined = riskItems.find((item) => item.value === customerRisk);

  const filteredHistories = histories.filter(
    (history: any) => history.fieldName === "customerRiskNote"
  );
  const noteHistories = filteredHistories.slice(1);

  const isSignificant = customerRisk === "Significant Risk";
  const isEscalationYes = String(escalationFlag) === "1";
  const lastUpdatedOn =
    filteredHistories.length > 0
      ? moment(filteredHistories[0].lastModifiedDate)
          .tz("America/Los_Angeles")
          .format("YYYY-MM-DD HH:mm:ss PT")
      : "N/A";

  return (
    <SuccessPlanCard
      titleSlot={
        <div className={styles["sp-flex-horizontal"]}>
          <span className={styles["sp-subtitle"]}>Overall Customer Health Risk</span>
          {/* <span className={styles["sp-red-star"]}>*</span> */}
        </div>
      }
    >
      <RiskLabel riskItem={riskItem} />

      <div className={`${styles["sp-flex-vertical"]}`}>
        <div className={styles["sp-flex-horizontal"]}>
          <Typography className={styles["sp-label-gray"]}>De-Risk Strategies:</Typography>
          <Typography className={styles["sp-label"]}>
            {deRiskStrategies?.length ? deRiskStrategies.join(", ") : "NA"}
          </Typography>
        </div>
      </div>

      <NoteWrapper
        riskNote={customerRiskNote}
        noteHistories={noteHistories}
        lastUpdatedOn={lastUpdatedOn}
      />
      {isSignificant && (
        <div className={`${styles["sp-flex-vertical"]}`}>
          <Typography className={styles["sp-label-gray"]}>
            Risk has been assessed as Significant. Please explain what the CS and Account Team are
            doing to address the risk:
          </Typography>
          <div
            dangerouslySetInnerHTML={{
              __html: significantDoing ?? "",
            }}
            style={{
              height: 200,
              border: "1px solid #ddd",
              borderRadius: 8,
              overflowY: "auto",
              padding: 14,
            }}
          ></div>
        </div>
      )}
      <div className={`${styles["sp-flex-vertical"]}`}>
        <div className={styles["sp-flex-horizontal"]}>
          <Typography className={styles["sp-label-gray"]}>
            Are there any concerning customer escalations?
          </Typography>
          <Typography className={styles["sp-label"]}>{isEscalationYes ? "Yes" : "No"}</Typography>
        </div>
      </div>
      {isEscalationYes && (
        <div className={`${styles["sp-flex-vertical"]}`}>
          <Typography className={styles["sp-label-gray"]}>Please explain:</Typography>
          <div
            dangerouslySetInnerHTML={{
              __html: escalationNote ?? "",
            }}
            style={{
              height: 200,
              border: "1px solid #ddd",
              borderRadius: 8,
              overflowY: "auto",
              padding: 14,
            }}
          ></div>
        </div>
      )}
    </SuccessPlanCard>
  );
};

export default CustomerHealthSection;
